import { Injectable } from '@angular/core'
import { ApplicationModel } from '@app/models/application.model'
import { BehaviorSubject } from 'rxjs'
import { filter, map } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class ApplicationsSelectedService {
  applicationCurrent$: BehaviorSubject<ApplicationModel | null> = new BehaviorSubject<ApplicationModel | null>(null)
  key = 'applicationData'
  constructor() {
    this.getFromLocal()
    this.applicationCurrent$.pipe(filter(s => !!s)).subscribe(
      app => {
        const data = localStorage.getItem(this.key)
        localStorage.setItem(this.key, JSON.stringify(app))
        if (!data || JSON.parse(data)?.applicationCode != app?.applicationCode) {
          // window.location.assign('/category/applications')
          window.location.reload()
        }
      }
    )
  }
  getFromLocal() {
    const data = localStorage.getItem(this.key)
    this.applicationCurrent$.next(data ? JSON.parse(data) : null)
  }
  set(data: ApplicationModel) {
    this.applicationCurrent$.next(data)
  }
  getCode() {
    return this.applicationCurrent$.value?.applicationCode
  }
  getCodeSubject() {
    return this.applicationCurrent$.pipe(map(a => a?.applicationCode))
  }
}
